import type { ReactElement } from 'react'

import clusterAppLinkIcon from '~/assets/cluster-app-link-icon.png'

import './styles.scss'

interface Props {
  href?: string
  label: string
  onClick?: VoidFunction
}

const ClusterAppExternalLink = ({ href, label, onClick }: Props): ReactElement => {
  return (
    <a className="cluster-app-external-link" href={href} onClick={onClick} rel="noreferrer" target="_blank">
      <label className="cluster-app-external-link__label">{label}</label>
      <img className="cluster-app-external-link__icon" src={clusterAppLinkIcon} />
    </a>
  )
}

export default ClusterAppExternalLink
